import {
    SET_PAGE,
    REQUEST_START,
    REQUEST_SUCCESS,
    REQUEST_ERROR,
} from 'state/actions/leaderboard'

export const RECORDS_PER_PAGE = 50

export const initialState = {
    vehicle_level: undefined,
    data: [],
    meta: {},
    page: null, // server returns clan page
    pagesTotal: 0,
    recordsPerPage: RECORDS_PER_PAGE,
    error: false,
    loading: false,
}

export default function reducer(state = initialState, action) {
    if (!action) return state

    switch (action.type) {
    case REQUEST_START: {
        return {
            ...state,
            loading: true,
        }
    }
    case SET_PAGE: {
        const { page, vehicle_level } = action.payload
        return {
            ...state,
            page,
            vehicle_level,
        }
    }
    case REQUEST_SUCCESS: {
        const { data, meta, page, pagesTotal } = action.payload
        return {
            ...state,
            data,
            meta,
            page,
            pagesTotal,
            error: false,
            loading: false,
        }
    }
    case REQUEST_ERROR: {
        return {
            ...state,
            error: true,
            pagesTotal: 0,
            loading: false,
        }
    }
    default:
        return state
    }
}



// WEBPACK FOOTER //
// ./state/reducers/leaderboard.js